export const getLoginPath = () => {
    const returnUrl = window.location.href.replace(
        new RegExp(`^${window.location.protocol}//${window.location.host}`),
        ''
    );

    const queryParams = new URLSearchParams(`returnUrl=${returnUrl}`);

    return `/login${queryParams.size > 0 ? `?${queryParams}` : ''}`;
};
